module.exports = __webpack_public_path__ + "img/fixed.3d58b77c.png";